import axios from "axios";

// Create an Axios instance with a base URL
const api = axios.create({
  baseURL: "https://izhub-service-885787520862.europe-west1.run.app",
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to include the token in the Authorization header
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token"); // Changed to sessionStorage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);

export default api;